import React from "react";
import { UsersFilterShape } from "../../../core/models/user";

interface EmailNotificationComposerProps {
    filter?: UsersFilterShape;
}

export const EmailNotificationComposer: React.FC<EmailNotificationComposerProps> = () => {
    return (
        <div className="notification-placeholder">
            <h4>Email composer</h4>
            <p>
                Канал зарезервирован в `v2`, но backend для email пока не реализован.
                Telegram теперь живет отдельно и больше не ограничен email-совместимой моделью.
            </p>
        </div>
    );
};
